import React, { useState, useEffect, useRef } from "react";
import { Image, Row, Col, Button, Container, ProgressBar } from 'react-bootstrap';
import { Spinner } from 'react-activity';
import * as CryptoJS from 'crypto-js';
import CardComponent from '../Card';
import BackIcon from '../../../../Images/back-arrow.svg';
import BlockIcon from '../../../../Images/bloquear.svg';
import UnblockIcon from '../../../../Images/desbloquear.svg';
import './digitalCards.css'
import Backend from '../../../../Backend';
import Connection from '../../../../Calls';
import { CounterHandler } from "./counterHandler";
import { ModalBlockVirtual } from "../Modals/ModalBlockVirtual";
import { store } from 'react-notifications-component';


const initial = {
  count: 0,
  expSeconds: 0,
};

const DEFAULT_COUNTER = 300;

export const DigitalCard = (props) => {
  const [counter, setCounter] = useState(() => initial);
  const interval = useRef(new CounterHandler()).current;
  const [countRunning, setCountRunning] = useState(false);
  const [key, setKey] = useState("");
  const [date, setDate] = useState("")
  const [hidden, setHidden] = useState(true);
  const [cardNumber, setCardNumber] = useState("");
  const [loading, setLoading] = useState(false);
  const [spinner, setSpinner] = useState(false);
  const [statusVirtual, setStatusVirtual] = useState("unblocked");
  const [modalBlock, setModalBlock] = useState(false);

  const copyNumberToClipboard = React.createRef();

  const clear = () => {
    interval.clear();
    setCounter(() => initial);
    setCountRunning(false);
    setKey("•••");
  }

  useEffect(() => {
    getCardVirtualData();
  },[])

  useEffect(() => {
    if (hidden) return;
    if (((counter.expSeconds - counter.count) != 0)) return;
  }, [hidden])

   useEffect(() => {
    if (countRunning) {
      interval.set(() => {
        setCounter((prev) => ({ ...prev, count: prev.count + 1 }));
      }, 1000);
    }
   }, [countRunning]);


   useEffect(() => {
    if (
      counter.count >= counter.expSeconds &&
      countRunning
    ) {
      clear();
    }
  }, [counter.count, countRunning]);

  const getVirtualKey = async() => {
    if (hidden) {
      setHidden(!hidden)
      if(counter.count >= counter.expSeconds) {
        setHidden(!hidden)
        setLoading(true)
        let date = new Date(), confirmation = Connection.Uwx6GVhZ(), result = "", combination = Connection.RThzHrsb("XCHF101"), latitude = "0", longitude = "0";
        navigator.geolocation.getCurrentPosition((success, error, options) => {
          latitude = success.coords.latitude;
          longitude = success.coords.longitude
        });
        result = latitude + longitude;
        Connection.EZcga8qH(confirmation, date, result, "XL7FefG", combination, "XCHF101", response => {
          Backend.GetVirtualKey(localStorage.getItem('email'), localStorage.getItem('token'), response.payload.r01, props.currentCard?.id,  "V", response => {
            if (response.status.code == '0'){
              setKey(response.payload.key)
              setCounter((prev) => ({
                ...prev,
                expSeconds: response.payload.timer
                  ? response.payload.timer
                  : DEFAULT_COUNTER,
                count: prev.count,
              }));
              setCountRunning(true);
              setLoading(false)
            } else {
              setLoading(false)
            }
          })
        })
      }
    } else {
      setHidden(!hidden)
    }

  }

  const getCardVirtualData = () =>{
    setLoading(true)
    let date = new Date(), confirmation = Connection.Uwx6GVhZ(), result = "", combination = Connection.RThzHrsb("XCHF101"), latitude = "0", longitude = "0";
    navigator.geolocation.getCurrentPosition((success, error, options) => {
      latitude = success.coords.latitude;
      longitude = success.coords.longitude
    });
    result = latitude + longitude;
    Connection.EZcga8qH(confirmation, date, result, "XL7FefG", combination, "XCHF101", response => {
      Backend.GetCardData2(localStorage.getItem('email'), localStorage.getItem('token'), response.payload.r01, props.currentCard?.id,  "V", response => {
        if (response.status.code == '0'){
          setStatusVirtual(response.payload.status)
          let enc_data = response['payload']['data'].split(':');
          let iv = CryptoJS.enc.Base64.parse(enc_data[0]);
          let msg_enc = enc_data[1];
          const secret = 'A571784D81D9494D';
          let key = CryptoJS.enc.Utf8.parse(secret);
          let decryptedWA = CryptoJS.AES.decrypt(enc_data[1], key, {
            iv: iv,
          });
          let dec_data = decryptedWA.toString(CryptoJS.enc.Utf8);
          setCardNumber(JSON.parse(dec_data).card)
          setDate(JSON.parse(dec_data).date)
          setLoading(false)
        }else {
          setLoading(false)
        }
      })
    })
  }


  const secondsToMinutes = (time) => {
    const minutes = Math.floor(time / 60); 
    const seconds = time - minutes * 60;

    return `${minutes}:${seconds.toLocaleString('en-US', {minimumIntegerDigits: 2, useGrouping:false})}`
  }

  const copyCardNumber = async (textToClipboard) => {
    if ('clipboard' in navigator) {
      await navigator.clipboard.writeText(textToClipboard);
      store.addNotification({
        title: props.traductions.Card.enabled.physicalCard.L_card_copied_title,
        message: props.traductions.Card.enabled.physicalCard.L_card_copied_message,
        type: "success",
        insert: "top",
        container: "top-right",
        animationIn: ["animated", "fadeIn"],
        animationOut: ["animated", "fadeOut"],
        dismiss: {
          duration: 1800,
          onScreen: true
        }

      });
      return;
    } else {
      copyNumberToClipboard.current.select();
      store.addNotification({
        title: props.traductions.Card.enabled.digitalCard.L_card_copied_title,
        message: props.traductions.Card.enabled.digitalCard.L_card_copied_message,
        type: "success",
        insert: "top",
        container: "top-right",
        animationIn: ["animated", "fadeIn"],
        animationOut: ["animated", "fadeOut"],
        dismiss: {
          duration: 1800,
          onScreen: true
        }

      });
      return document.execCommand('copy', false, textToClipboard);
    }
    
  }


  const handleBlockDigitalCard = () => {
    setHidden(true);
    setSpinner(true)
    let action = statusVirtual === 'unblocked' ? 'block': 'unblock'
    let date = new Date(), confirmation = Connection.Uwx6GVhZ(), result = "", combination = Connection.RThzHrsb("XCHF101"), latitude = "0", longitude = "0";
    navigator.geolocation.getCurrentPosition((success, error, options) => {
      latitude = success.coords.latitude;
      longitude = success.coords.longitude
    });
    result = latitude + longitude;
    Connection.EZcga8qH(confirmation, date, result, "XL7FefG", combination, "XCHF101", response => {
      var payload = response.payload;
      Backend.BlockCard(localStorage.getItem('email'), localStorage.getItem('token'), action, props.current?.id, "V", payload.r01, response => {
        if(response.status.code =='0'){
          setSpinner(false)
          setModalBlock(false)
          getCardVirtualData();
        } else {
          setSpinner(false)
          setModalBlock(false)
        }
      })
    })
    
  }

  return (
    <div>
      <center>
        <Row style={{marginTop: '70px', width: '380px', marginBottom: '42px'}}>
          <Col xl={3} lg={3}>
            <Image className="back-navigation" src={BackIcon} onClick={() => {props.setRenderComponent("card"); props.getSlide(props.slide)}}/>
          </Col>
          <Col xl={6} lg={6} style={{textAlign: 'center'}}>
            <span>{props.traductions.Card.enabled.digitalCard.title}</span>
          </Col>
        </Row>
      </center>
      <center>
        <div>
          <CardComponent url={props.currentCard?.image} variant={'digital-card'} unblocked={statusVirtual === 'unblocked' ? true : false}/>
        </div>
      </center>
      <center>
        {
          loading ?
          <div style={{display:'flex',justifyContent:'center',alignItems:'center',height:'240px'}}>
            <Spinner animated color='#053164' size={90}/>
          </div>
            :
            <>
            <Row style={{width: '325px', marginTop: '55px'}}>
              <Col xl={12} style={{display: 'flex', justifyContent: 'space-between'}}>
                <div style={{textAlign: 'left'}}>
                  <span>{props.traductions.Card.enabled.digitalCard.L_card_number}</span><br/>
                  <input style={{width: '192px'}} className="clipboard-input" ref={copyNumberToClipboard} value={cardNumber.replace(/[^\dA-Z]/g, '').replace(/(.{4})/g, '$1 ').trim()}></input>
                </div>
                <div>
                  <Button onClick={() => copyCardNumber(cardNumber)} className='copy-btn'>{props.traductions.Card.enabled.digitalCard.L_copy}</Button>
                </div>
              </Col>

              <Col xl={12} style={{ marginTop: '30px', textAlign: 'initial'}}>
                <span>{props.traductions.Card.enabled.digitalCard.L_expiration_date}</span><br/>
                <span>{date}</span>
              </Col>

            <Col xl={12} style={{display: 'flex', justifyContent: 'space-between', marginTop: '30px'}}>
              <div style={{textAlign: 'left'}}>
                <span>{props.traductions.Card.enabled.digitalCard.L_cvv}</span><br/>
                {
                  hidden ? 
                  <span style={{fontSize: '8px'}}>⬤⬤⬤</span>
                    :
                  <span>{key}</span>
                }
              </div>
              <div style={{display: 'flex', alignItems: 'flex-end'}}>
                <Button id="cvv-button"  disabled={(statusVirtual !== 'unblocked')} onClick={() => getVirtualKey()} className='gray-hidden-key'>{hidden ? props.traductions.Card.enabled.digitalCard.L_show : props.traductions.Card.enabled.digitalCard.L_hide}</Button>
              </div>
            </Col>
          </Row>

          {/* Progress Bar */}
          {hidden ? <></> : <>
          <div className="progress-bar-wrapper" style={{marginTop: '30px'}}>
            <ProgressBar now={counter.expSeconds - counter.count} max={300} min={0} style={{backgroundColor: '#E4EAF8', height: "9px", borderRadius: 0}}/>
          </div>
          <div className='cvv-section'>
            <Row style={{height: '100%', alignItems: 'center', paddingLeft: '19%', paddingRight: '19%'}}>
              <Col xl={9}>
                <div>
                  <span className="cvv-timer-text">{props.traductions.Card.enabled.digitalCard.L_time_warning_1}</span><br/>
                  <span className="cvv-timer-text">{props.traductions.Card.enabled.digitalCard.L_time_warning_2}</span>
                </div>
              </Col>
              <Col xl={3} style={{display: 'flex', justifyContent: 'flex-end'}}>
                <div className='rounded-timer'>
                    {secondsToMinutes(counter.expSeconds - counter.count)}
                </div>
              </Col>
            </Row>
          </div>
          </>}
          <div style={{marginTop: '30px', display: 'flex', justifyContent: 'center', marginBottom: '30px'}}>
            <Button className={statusVirtual === 'unblocked' ? 'gray-btn' :'black-btn'} onClick={() => setModalBlock(true)} style={{width: '184px'}}><Image src={statusVirtual === 'unblocked' ? BlockIcon : UnblockIcon} style={{marginRight: 6}}/>{statusVirtual === 'unblocked' ? props.traductions.Card.enabled.btn_StatusB : props.traductions.Card.enabled.btn_StatusU}</Button>
          </div>
          <ModalBlockVirtual {...props} unblocked={statusVirtual === 'unblocked' ? true : false} show={modalBlock} block={handleBlockDigitalCard} closeModal={() => setModalBlock(false)} spinner={spinner} />
          </>
        }
      </center>

      
    </div>
  )
}